export default __webpack_public_path__ + "static/media/tqicon-6.467074d3.svg";